<!--    個人資料-->
<template>
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{$t('message.profile')}}</span>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
            </vs-col>
        </vs-row>

        <vs-row v-if="isMobile()" class="profile" vs-type="flex">
            <vs-col vs-w="12" class="textAlignCenter">
                <vs-avatar size="200px" :src="profilePic" @click="edit ? $refs.file.click() : ''"/>
                <input @change="uploadProfilePic($event)" id="file1" ref="file"  type="file"  name="file" style="display: none;"/>
                <vs-button v-if="!edit" radius color="rgb(37, 105, 193)" size="small" class="profile-edit-mob" @click="edit = true">Edit</vs-button>
            </vs-col>
            <vs-col vs-w="12">
                <div class="profile-title-mob">
                    <p>{{$t('message.username')}} : {{currentUser.username}}</p>
                    <p v-if="currentUser.customer">{{$t('message.customerCode')}} : {{currentUser.customer.code}}</p>
                    <p style="font-size: 15px" v-if="currentUser.agentNumber">{{$t('message.agentNo')}} : {{currentUser.agentNumber}}</p>
                </div>
                <div class="profile-body-mob m-t-1">
                    <p>{{$t('message.name')}} : {{currentUser.name}}</p>
                    <p v-if="currentUser.customer">{{$t('message.gender')}} : {{$t(`message.${currentUser.customer.gender}`)}}</p>
                    <p v-if="currentUser.customer">{{$t('message.dateOfBirth')}} : {{currentUser.customer.dateOfBirth | dateFormat}}</p>
                    <p v-if="!edit">{{$t('message.phone')}} : {{currentUser.phone}}</p>
                    <div v-else class="edit-input-mob">
                        <span>{{$t('message.phone')}} : </span>
                        <vs-input style="display: inline-block;width: 300px" v-model="phone"></vs-input>
                    </div>
                    <p v-if="!edit">{{$t('message.email')}} : {{currentUser.email}}</p>
                    <div v-else class="edit-input-mob">
                        <span>{{$t('message.email')}} : </span>
                        <vs-input style="display: inline-block;width: 300px" v-model="email"></vs-input>
                    </div>
                    </div>
                    <p v-if="currentUser.customer">{{$t('message.residentialAddress')}} : {{currentUser.customer.residenceAddress}}</p>
                    <p v-if="currentUser.customer">{{$t('message.corrAddress')}} : {{currentUser.customer.correspondenceAddress}}</p>
            </vs-col>
        </vs-row>
        <vs-row v-else class="profile" vs-type="flex">
            <vs-col vs-w="2" vs-sm="0"></vs-col>
            <vs-col vs-w="5" vs-sm="7">
                <div class="profile-title">
                    <p>{{$t('message.username')}} : {{currentUser.username}}</p>
                    <p v-if="currentUser.customer">{{$t('message.customerCode')}} : {{currentUser.customer.code}}</p>
                    <p style="font-size: 15px" v-if="currentUser.agentNumber">{{$t('message.agentNo')}} : {{currentUser.agentNumber}}</p>
                </div>
                <div class="profile-body">
                    <p>{{$t('message.name')}} : {{currentUser.name}}</p>
                    <p v-if="currentUser.customer">{{$t('message.gender')}} : {{$t(`message.${currentUser.customer.gender}`)}}</p>
                    <p v-if="currentUser.customer">{{$t('message.dateOfBirth')}} : {{currentUser.customer.dateOfBirth | dateFormat}}</p>
                    <p v-if="!edit">{{$t('message.phone')}} : {{currentUser.phone}}</p>
                    <div v-else class="edit-input">
                        <span>{{$t('message.phone')}} : </span>
                        <vs-input style="display: inline-block;width: 300px" v-model="phone"></vs-input>
                    </div>
                    <p v-if="!edit">{{$t('message.email')}} : {{currentUser.email}}</p>
                    <div v-else class="edit-input">
                        <span>{{$t('message.email')}} : </span>
                        <vs-input style="display: inline-block;width: 300px" v-model="email"></vs-input>
                    </div>
                    <p v-if="currentUser.customer">{{$t('message.residentialAddress')}} : {{currentUser.customer.residenceAddress}}</p>
                    <p v-if="currentUser.customer">{{$t('message.corrAddress')}} : {{currentUser.customer.correspondenceAddress}}</p>
                </div>
            </vs-col>
            <vs-col vs-w="5" vs-sm="5">
                <vs-avatar size="250px" :src="profilePic" @click="edit ? $refs.file.click() : ''"/>
                <input @change="uploadProfilePic($event)" id="file" ref="file"  type="file"  name="file" style="display: none;"/>
                <vs-button v-if="!edit" radius color="rgb(37, 105, 193)" size="small" class="edit" @click="edit = true">Edit</vs-button>
            </vs-col>
        </vs-row>
        <vs-row v-if="edit">
            <vs-col vs-w="10" vs-type="flex" vs-justify="flex-end">
                <vs-button color="rgb(37, 105, 193)" size="small" @click="onSubmit()" style="margin-right: 10px;">{{$t('message.confirm')}}</vs-button>
                <vs-button color="danger" type="border" size="small" @click="onCancel()">{{$t('message.cancel')}}</vs-button>
            </vs-col>
        </vs-row>

    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'
    import moment from 'moment'
    export default {
        data() {
            return {
                token:'',
                edit:false,
                phone:'',
                email:'',
                profilePic:'',
                profilePicId:'',
                error:false
            }
        },
        created() {
            this.token = this.$cookies.get('token');

        },
        mounted() {
            this.phone = this.$store.getters.currentUser.phone || '';
            this.email = this.$store.getters.currentUser.email || '';
            this.profilePic = this.$store.getters.currentUser.profilePic.fileUrl || '';
        },
        computed:{
            ...mapGetters(["currentUser"])
        },
        methods: {
            ...mapActions(["getUser"]),
            uploadProfilePic(e){
                let file = e.target.files[0];
                let formData = new FormData();
                formData.append("file", file);
                let url = process.env.VUE_APP_API_BASEURL + '/api/attachment/upload?access_token=' + this.token;
                fetch(url, {
                    method: 'POST',
                    body: formData
                }).then((response) => {
                    return response.json()
                }).catch((error) => {
                    console.log(error);
                }).then((result) => {
                    console.log(result)
                    this.profilePic = result.responseDetail.fileUrl
                    this.profilePicId = result.responseDetail._id

                });
            },
            onSubmit(){
                let url = process.env.VUE_APP_API_BASEURL + '/api/user/' + this.currentUser._id + '?access_token=' + this.token;

                fetch(url,{
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, *!/!*',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        phone:this.phone,
                        email:this.email,
                        profilePic:this.profilePicId ? this.profilePicId : this.currentUser.profilePic,
                    })
                }).then((response)=>{
                    return response.json()
                }).then((res)=>{
                    this.edit = false;
                    if(res.responseCode === 200){
                        this.getUser({
                            token:this.token
                        })
                    }else if(res.responseCode == "61006"){
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.oldPwdErrorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }else{
                        this.$vs.notify({
                            title:'提示',
                            text: this.$t('message.errorMsg'),
                            icon: 'clear',
                            color:'danger',
                            position:'top-center',
                            time: 3000
                        });
                    }
                })

            },
            onCancel(){
                this.edit = false;
                this.phone = this.currentUser.phone;
                this.email = this.currentUser.email;
            },
        },
        filters:{
            dateFormat(val){
                return moment(val).format('YYYY-MM-DD')
            }
        }
    }
</script>

<style scoped>
    @import "../assets/css/profile.css";

</style>
<style>
    .danger .vs-input--input{
        border-color: red !important;
    }
    .danger .vs-input--input:focus{
        border-color: red !important;
    }
</style>
